import { render, staticRenderFns } from "./ModalAddContact.vue?vue&type=template&id=737630fd&"
import script from "./ModalAddContact.vue?vue&type=script&lang=js&"
export * from "./ModalAddContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports